var _defs, _path, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApp2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4322",
    "data-name": "Group 4322",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270.496,
    height: 88.483,
    viewBox: "0 0 270.496 88.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14071",
    "data-name": "Path 14071",
    d: "M173.336,351.029l-12.2-7.042L137.613,330.4c-1.306-.754-2.607-.3-2.607,1.279v55.344c0,1.181.93,1.691,2.065,1.036l24.068-13.9,12.2-7.042,11.724-6.768c1.376-.795,1.243-1.885.083-2.51S173.336,351.029,173.336,351.029Z",
    transform: "translate(-135.006 -330.047)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006aa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#2f8da6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#66b6ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7cc6af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab59d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfe385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4282d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#ba2d4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#83357b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e388d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f07165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#faa460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffba5e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14066",
    "data-name": "Path 14066",
    d: "M367.137,372.6a11.957,11.957,0,0,1-11.955,11.959H108.6A11.96,11.96,0,0,1,96.641,372.6V308.032A11.959,11.959,0,0,1,108.6,296.074H355.182a11.957,11.957,0,0,1,11.955,11.958Z",
    transform: "translate(-96.641 -296.074)",
    fill: "#1a1818"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLAY",
    transform: "translate(20.289 17.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4317",
    "data-name": "Group 4317",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14067",
    "data-name": "Path 14067",
    d: "M135.006,328.285v59.92l30.215-29.96Z",
    transform: "translate(-135.006 -329.217)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14068",
    "data-name": "Path 14068",
    d: "M173.337,350l-12.2-7.042-26.134-15.089v.218l30.215,29.961Z",
    transform: "translate(-135.006 -329.023)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14069",
    "data-name": "Path 14069",
    d: "M135.006,414.9v.218l26.134-15.09,12.2-7.041-8.115-8.046Z",
    transform: "translate(-135.006 -355.909)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14070",
    "data-name": "Path 14070",
    d: "M200.255,369.721l-8.116,8.047,8.115,8.046,13.939-8.047Z",
    transform: "translate(-161.925 -348.74)",
    fill: "url(#linear-gradient-4)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4318",
    "data-name": "Group 4318",
    transform: "translate(202.405 33.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14072",
    "data-name": "Path 14072",
    d: "M487.476,390.994a7.535,7.535,0,0,1-3.108-.628,5.859,5.859,0,0,1-2.362-1.931h-.19a23.421,23.421,0,0,1,.19,2.893v7.17h-2.638V373.25h2.146l.365,2.385h.127a6.135,6.135,0,0,1,2.37-2.067,7.2,7.2,0,0,1,3.1-.636,6.441,6.441,0,0,1,5.35,2.369,12.618,12.618,0,0,1-.03,13.317A6.456,6.456,0,0,1,487.476,390.994Zm-.382-15.82a4.677,4.677,0,0,0-3.863,1.479,7.614,7.614,0,0,0-1.225,4.707v.588q0,3.673,1.225,5.255a4.656,4.656,0,0,0,3.927,1.581,4.085,4.085,0,0,0,3.539-1.828,8.675,8.675,0,0,0,1.279-5.041,8.35,8.35,0,0,0-1.279-5A4.213,4.213,0,0,0,487.094,375.174Z",
    transform: "translate(-479.368 -365.936)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14073",
    "data-name": "Path 14073",
    d: "M517.583,384.443h-2.64V359.7h2.64Z",
    transform: "translate(-496.13 -359.703)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14074",
    "data-name": "Path 14074",
    d: "M537.918,390.7l-.525-2.48h-.127a7.311,7.311,0,0,1-2.6,2.218,7.9,7.9,0,0,1-3.235.581,5.822,5.822,0,0,1-4.062-1.335,4.869,4.869,0,0,1-1.471-3.8q0-5.278,8.443-5.533l2.958-.1v-1.08a4.413,4.413,0,0,0-.883-3.029,3.626,3.626,0,0,0-2.822-.978,11.492,11.492,0,0,0-4.929,1.336l-.811-2.02a12.4,12.4,0,0,1,2.823-1.1,12.219,12.219,0,0,1,3.076-.4,6.639,6.639,0,0,1,4.619,1.383,5.778,5.778,0,0,1,1.5,4.437V390.7Zm-5.962-1.859a5.361,5.361,0,0,0,3.872-1.351,5,5,0,0,0,1.407-3.785v-1.574l-2.641.111a9.6,9.6,0,0,0-4.539.979,2.948,2.948,0,0,0-1.391,2.694,2.715,2.715,0,0,0,.867,2.178A3.593,3.593,0,0,0,531.956,388.844Z",
    transform: "translate(-501.29 -365.964)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14075",
    "data-name": "Path 14075",
    d: "M555.222,373.533h2.829l3.816,9.938a37.965,37.965,0,0,1,1.559,4.914h.127q.206-.812.866-2.776t4.317-12.075h2.831l-7.49,19.843a9.9,9.9,0,0,1-2.6,4.175,5.529,5.529,0,0,1-3.648,1.231,10.674,10.674,0,0,1-2.386-.269V396.4a9.22,9.22,0,0,0,1.956.191q2.719,0,3.88-3.054l.969-2.48Z",
    transform: "translate(-515.107 -366.219)",
    fill: "#f9f9f9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4320",
    "data-name": "Group 4320",
    transform: "translate(82.085 31.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14076",
    "data-name": "Path 14076",
    d: "M390.138,375.426a6.144,6.144,0,0,1,2.587,4.921c0,2.7-1.531,3.974-3.062,5.175a2.564,2.564,0,0,0-1.021,1.788,2,2,0,0,0,.949,1.566l1.313,1.019c1.6,1.349,3.06,2.589,3.06,5.1,0,3.426-3.317,6.888-9.585,6.888-5.286,0-7.836-2.514-7.836-5.213a5.244,5.244,0,0,1,2.807-4.447c2.258-1.385,5.322-1.565,6.961-1.678a3.814,3.814,0,0,1-1.094-2.476,3.289,3.289,0,0,1,.365-1.424c-.4.038-.8.073-1.168.073A5.762,5.762,0,0,1,378.364,381a6.557,6.557,0,0,1,2.332-4.884,9.94,9.94,0,0,1,6.527-2.005h7.507l-2.333,1.313Zm-2.589,16.184a5.656,5.656,0,0,0-.837-.038,14.582,14.582,0,0,0-3.828.586c-.8.289-3.135,1.165-3.135,3.753s2.516,4.448,6.417,4.448c3.5,0,5.358-1.68,5.358-3.938C391.524,394.558,390.321,393.578,387.549,391.609Zm1.058-6.926a3.687,3.687,0,0,0,.909-2.662c0-2.624-1.566-6.705-4.59-6.705a3.4,3.4,0,0,0-2.552,1.2,4.211,4.211,0,0,0-.8,2.7c0,2.442,1.422,6.487,4.558,6.487A3.732,3.732,0,0,0,388.607,384.684Z",
    transform: "translate(-310.602 -364.544)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14077",
    "data-name": "Path 14077",
    d: "M350.951,390.565a8.588,8.588,0,0,1-8.878-8.59c0-4.767,3.893-8.841,9.426-8.841a8.507,8.507,0,0,1,8.7,8.587A8.892,8.892,0,0,1,350.951,390.565Zm4.548-2.947a6.583,6.583,0,0,0,1.093-4.04c0-3.2-1.528-9.316-6.041-9.316a5.069,5.069,0,0,0-3.274,1.239,5.506,5.506,0,0,0-1.675,4.441c0,3.6,1.783,9.529,6.188,9.529A4.648,4.648,0,0,0,355.5,387.618Z",
    transform: "translate(-294.362 -364.083)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14078",
    "data-name": "Path 14078",
    d: "M313.655,390.565a8.588,8.588,0,0,1-8.879-8.59c0-4.767,3.894-8.841,9.426-8.841a8.507,8.507,0,0,1,8.7,8.587A8.892,8.892,0,0,1,313.655,390.565Zm4.549-2.947a6.592,6.592,0,0,0,1.092-4.04c0-3.2-1.529-9.316-6.042-9.316a5.071,5.071,0,0,0-3.275,1.239,5.506,5.506,0,0,0-1.674,4.441c0,3.6,1.782,9.529,6.187,9.529A4.651,4.651,0,0,0,318.2,387.618Z",
    transform: "translate(-276.789 -364.083)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14079",
    "data-name": "Path 14079",
    d: "M277.063,382.657l-5.232,1.207a38.778,38.778,0,0,1-6.036.62c-10.1,0-13.939-7.427-13.939-13.245,0-7.1,5.45-13.68,14.781-13.68a21.059,21.059,0,0,1,5.6.768,14.264,14.264,0,0,1,4.829,2.268l-3.037,2.89-1.28.291.914-1.463a10.456,10.456,0,0,0-7.829-3.438c-5.781,0-10.135,4.392-10.135,10.794,0,6.876,4.976,13.352,12.95,13.352a10.9,10.9,0,0,0,4.647-.915v-5.889l-5.523.292,2.925-1.575h7.757l-.95.914a.855.855,0,0,0-.367.584c-.038.33-.072,1.392-.072,1.757Z",
    transform: "translate(-251.856 -356.745)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14080",
    "data-name": "Path 14080",
    d: "M417.192,380.877c-1.208-.11-1.461-.328-1.461-1.757V358.414c.007-.079.013-.16.02-.236.148-1.28.512-1.5,1.648-2.159h-5.234l-2.745,1.317h2.8v.016l0-.013v22.587c0,.73-.144.841-.987,1.938h6.476l1.353-.8C418.438,380.986,417.815,380.95,417.192,380.877Z",
    transform: "translate(-326.093 -356.019)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14081",
    "data-name": "Path 14081",
    d: "M440.451,389.287c-.4.218-.8.474-1.2.654a8.462,8.462,0,0,1-3.528.691,7.764,7.764,0,0,1-4.833-1.418,9.4,9.4,0,0,1-3.7-7.667,8.235,8.235,0,0,1,8.32-8.392,7.062,7.062,0,0,1,3.744,1.018,6.015,6.015,0,0,1,2.54,3.6l-8.536,3.453-2.8.218c.907,4.614,4.031,7.3,7.484,7.3a9.388,9.388,0,0,0,4.432-1.269Zm-3.414-10.828c.689-.254,1.052-.472,1.052-.98a3.605,3.605,0,0,0-3.6-3.124c-1.455,0-4.178,1.127-4.178,5.05,0,.618.072,1.271.111,1.927Z",
    transform: "translate(-334.465 -364.093)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4319",
    "data-name": "Group 4319",
    transform: "translate(108.409 9.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14082",
    "data-name": "Path 14082",
    d: "M457.93,373.4v2.4h-.291v-2.4h-.793v-.249h1.877v.249Z",
    transform: "translate(-456.846 -373.156)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14083",
    "data-name": "Path 14083",
    d: "M463.3,375.8v-2.419h-.013l-.739,2.419h-.227l-.745-2.419h-.009V375.8H461.3v-2.646h.453l.674,2.139h.009l.664-2.139h.46V375.8Z",
    transform: "translate(-458.944 -373.156)",
    fill: "#f9f9f9"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4321",
    "data-name": "Group 4321",
    transform: "translate(82.148 17.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14084",
    "data-name": "Path 14084",
    d: "M259.177,337.5H257.36a12.059,12.059,0,0,0-.517-2.125h-2.625a10.981,10.981,0,0,0-.534,2.125h-1.71q0-.221,1.326-3.636a28.592,28.592,0,0,0,1.327-3.761h2.147a31.4,31.4,0,0,0,1.2,3.706A32.456,32.456,0,0,1,259.177,337.5Zm-2.625-3.21a32.143,32.143,0,0,1-.972-3.17h-.091q0,.222-1.005,3.17Z",
    transform: "translate(-251.974 -329.932)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14085",
    "data-name": "Path 14085",
    d: "M274.016,337.5h-1.4a13.829,13.829,0,0,0-1.562-2.46,13.549,13.549,0,0,1-1.863-3.21H269.1a20.024,20.024,0,0,1,.142,2.25q0,1.4.079,3.42h-1.4q.086-1.761.085-3.869,0-2.074-.085-3.527h1.688a10.689,10.689,0,0,0,1.4,2.4,14.148,14.148,0,0,1,1.716,3.028h.085a21.568,21.568,0,0,1-.136-2.272q0-1.539-.08-3.158h1.421q-.08,1.409-.08,3.527Q273.936,335.767,274.016,337.5Z",
    transform: "translate(-259.487 -329.932)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14086",
    "data-name": "Path 14086",
    d: "M289.449,333.515a4.19,4.19,0,0,1-1.034,2.818,3.611,3.611,0,0,1-2.9,1.2q-.841,0-2.318-.068.074-1.716.074-3.869,0-2.067-.074-3.527h.994q.244,0,.727-.017t.63-.017a3.83,3.83,0,0,1,2.974,1.023A3.535,3.535,0,0,1,289.449,333.515Zm-1.551.244a2.737,2.737,0,0,0-.636-1.838,2.412,2.412,0,0,0-1.943-.747,6.024,6.024,0,0,0-.671.051q.057,1.137.057,2.375,0,1.358.057,2.693a3.763,3.763,0,0,0,.739.074,2.147,2.147,0,0,0,1.809-.759A2.927,2.927,0,0,0,287.9,333.759Z",
    transform: "translate(-266.686 -329.902)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14087",
    "data-name": "Path 14087",
    d: "M304.039,337.469h-1.682a11.155,11.155,0,0,0-1.011-2.482,1.324,1.324,0,0,0-1.136-.472c-.22,0-.43,0-.631.006q0,1.46.051,2.948h-1.579q.074-1.716.074-3.869,0-2.067-.074-3.527h.983q.171,0,.713-.017t1-.017q2.607,0,2.608,1.784a2,2,0,0,1-1.489,1.972v.085a1.775,1.775,0,0,1,1.006.894A19.769,19.769,0,0,1,304.039,337.469Zm-2.13-5.227q0-1.13-1.454-1.131a4.951,4.951,0,0,0-.943.08q.063.881.063,2.3.312.011.528.011Q301.908,333.5,301.908,332.242Z",
    transform: "translate(-273.683 -329.902)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14088",
    "data-name": "Path 14088",
    d: "M318.328,333.513a4.081,4.081,0,0,1-1.068,2.892,3.466,3.466,0,0,1-2.642,1.148,3.338,3.338,0,0,1-2.511-1.055,3.709,3.709,0,0,1-1.011-2.678,4.077,4.077,0,0,1,1.068-2.892,3.465,3.465,0,0,1,2.642-1.148,3.342,3.342,0,0,1,2.511,1.051A3.708,3.708,0,0,1,318.328,333.513Zm-1.568.164a2.932,2.932,0,0,0-.608-1.926,1.871,1.871,0,0,0-1.5-.739,1.732,1.732,0,0,0-1.409.745,2.97,2.97,0,0,0-.58,1.88,2.925,2.925,0,0,0,.611,1.923,1.871,1.871,0,0,0,1.5.741,1.73,1.73,0,0,0,1.409-.747A2.972,2.972,0,0,0,316.761,333.677Z",
    transform: "translate(-279.83 -329.78)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14089",
    "data-name": "Path 14089",
    d: "M329.413,337.5H327.8q.074-1.761.074-3.869,0-2.074-.074-3.527h1.608q-.074,1.431-.074,3.527Q329.339,335.773,329.413,337.5Z",
    transform: "translate(-287.702 -329.932)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14090",
    "data-name": "Path 14090",
    d: "M340.848,333.515a4.189,4.189,0,0,1-1.034,2.818,3.611,3.611,0,0,1-2.9,1.2q-.841,0-2.318-.068.074-1.716.074-3.869,0-2.067-.074-3.527h.994q.244,0,.727-.017t.63-.017a3.83,3.83,0,0,1,2.974,1.023A3.537,3.537,0,0,1,340.848,333.515Zm-1.551.244a2.74,2.74,0,0,0-.636-1.838,2.412,2.412,0,0,0-1.943-.747,6.015,6.015,0,0,0-.671.051q.057,1.137.057,2.375,0,1.358.057,2.693a3.763,3.763,0,0,0,.739.074,2.147,2.147,0,0,0,1.809-.759A2.927,2.927,0,0,0,339.3,333.759Z",
    transform: "translate(-290.903 -329.902)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14091",
    "data-name": "Path 14091",
    d: "M360.653,337.5h-1.818a11.979,11.979,0,0,0-.518-2.125h-2.625a10.961,10.961,0,0,0-.534,2.125h-1.71q0-.221,1.326-3.636A28.54,28.54,0,0,0,356.1,330.1h2.147a31.343,31.343,0,0,0,1.2,3.706A32.594,32.594,0,0,1,360.653,337.5Zm-2.625-3.21a32.248,32.248,0,0,1-.972-3.17h-.09q0,.222-1.005,3.17Z",
    transform: "translate(-299.784 -329.932)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14092",
    "data-name": "Path 14092",
    d: "M374.793,332.01a2.215,2.215,0,0,1-1.009,2.005,4.485,4.485,0,0,1-2.473.647q-.267,0-.381-.011,0,1.068.062,2.818h-1.6q.074-1.641.074-3.869,0-2.045-.074-3.527h.989q.209,0,.806-.017t1.034-.017a3.251,3.251,0,0,1,1.823.489A1.652,1.652,0,0,1,374.793,332.01Zm-1.466.312q0-1.215-1.614-1.215a4.54,4.54,0,0,0-.852.085q.063,1.073.062,2.431.142.012.329.012Q373.327,333.634,373.327,332.322Z",
    transform: "translate(-307.297 -329.902)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14093",
    "data-name": "Path 14093",
    d: "M387.677,332.01a2.215,2.215,0,0,1-1.008,2.005,4.488,4.488,0,0,1-2.474.647c-.178,0-.3,0-.38-.011q0,1.068.062,2.818h-1.6q.074-1.641.074-3.869,0-2.045-.074-3.527h.988q.21,0,.807-.017t1.034-.017a3.251,3.251,0,0,1,1.823.489A1.652,1.652,0,0,1,387.677,332.01Zm-1.465.312q0-1.215-1.614-1.215a4.54,4.54,0,0,0-.852.085q.063,1.073.062,2.431c.095.008.2.012.329.012Q386.211,333.634,386.211,332.322Z",
    transform: "translate(-313.368 -329.902)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14094",
    "data-name": "Path 14094",
    d: "M407.107,333.513a4.079,4.079,0,0,1-1.068,2.892,3.465,3.465,0,0,1-2.642,1.148,3.338,3.338,0,0,1-2.511-1.055,3.712,3.712,0,0,1-1.011-2.678,4.08,4.08,0,0,1,1.068-2.892,3.467,3.467,0,0,1,2.642-1.148,3.342,3.342,0,0,1,2.511,1.051A3.71,3.71,0,0,1,407.107,333.513Zm-1.568.164a2.929,2.929,0,0,0-.608-1.926,1.87,1.87,0,0,0-1.5-.739,1.733,1.733,0,0,0-1.409.745,2.969,2.969,0,0,0-.579,1.88,2.925,2.925,0,0,0,.611,1.923,1.87,1.87,0,0,0,1.5.741,1.729,1.729,0,0,0,1.409-.747A2.969,2.969,0,0,0,405.539,333.677Z",
    transform: "translate(-321.658 -329.78)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14095",
    "data-name": "Path 14095",
    d: "M422.68,337.5h-1.4a13.829,13.829,0,0,0-1.562-2.46,13.558,13.558,0,0,1-1.864-3.21h-.09a20.137,20.137,0,0,1,.142,2.25q0,1.4.08,3.42h-1.4q.085-1.761.085-3.869,0-2.074-.085-3.527h1.687a10.7,10.7,0,0,0,1.4,2.4,14.146,14.146,0,0,1,1.716,3.028h.085a21.44,21.44,0,0,1-.136-2.272q0-1.539-.079-3.158h1.42q-.079,1.409-.079,3.527Q422.6,335.767,422.68,337.5Z",
    transform: "translate(-329.53 -329.932)",
    fill: "#f7f8f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp2);
export default __webpack_public_path__ + "static/media/app2.74012f72cca0ae2fff5c1e9c9427c868.svg";
export { ForwardRef as ReactComponent };